import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export const CrossCircleIcon = (props: IconProps): ReactElement => (
  <IconWrapper {...props}>
    <path
      d="M12 4C7.584 4 4 7.584 4 12C4 16.416 7.584 20 12 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 12 4ZM12 18.4C8.472 18.4 5.6 15.528 5.6 12C5.6 8.472 8.472 5.6 12 5.6C15.528 5.6 18.4 8.472 18.4 12C18.4 15.528 15.528 18.4 12 18.4Z"
      fill="currentColor"
    />
    <path
      d="M15.6617 9.26684L15.7678 9.16077L15.6617 9.0547L14.9455 8.33851L14.8395 8.23245L14.7334 8.33851L12.0001 11.0718L9.26679 8.33851L9.16072 8.23245L9.05466 8.33851L8.33847 9.0547L8.2324 9.16077L8.33847 9.26684L11.0718 12.0001L8.33847 14.7334L8.2324 14.8395L8.33847 14.9456L9.05466 15.6618L9.16072 15.7678L9.26679 15.6618L12.0001 12.9285L14.7334 15.6618L14.8395 15.7678L14.9455 15.6618L15.6617 14.9456L15.7678 14.8395L15.6617 14.7334L12.9284 12.0001L15.6617 9.26684Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.3"
    />
  </IconWrapper>
);
